import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/vc-marketplace/vc-marketplace/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vc-marketplace/vc-marketplace/src/app/globals.css");
